import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const DICT = {
  it: {
    // Navbar
    nav_pricing: "Piani", nav_security: "Sicurezza", nav_faq: "FAQ", nav_support: "Supporto",
    nav_login: "Accedi", nav_signup: "Registrati", nav_logout: "Esci",
    nav_dashboard: "Dashboard", nav_redeem: "Riscatta codice",
    // Scarcity banner
    banner_pre: "Offerta a vita limitata a",
    banner_licenses: "licenze",
    banner_remain: "- Restano",
    banner_until: "licenze fino a fine 2026",
    // Hero
    hero_badge: "Cloud storage con licenza a vita",
    hero_title_1: "Il tuo cloud.",
    hero_title_2: "Una volta, per sempre.",
    hero_sub: "Paga una volta e ottieni fino a",
    hero_sub_2: "di storage sicuro a vita. Zero abbonamenti, zero sorprese. Solo le prime",
    hero_sub_3: "disponibili fino a fine 2026.",
    hero_cta_pricing: "Scegli il tuo piano",
    hero_cta_redeem: "Ho un codice",
    // Pricing
    pricing_title_1: "Piani",
    pricing_title_2: "a vita",
    pricing_sub: "Un solo pagamento, storage per sempre. Un codice monouso viene inviato via email dopo l'acquisto.",
    pricing_email_label: "Email per ricevere il codice",
    gift_label: "Comprare come regalo",
    gift_desc: "Il codice sara inviato all'email del destinatario",
    gift_recipient: "Email del destinatario",
    price_once: "/ una volta",
    price_lifetime: "A vita - nessun rinnovo",
    buy_prefix: "Acquista",
    // Support
    support_title_1: "Contatta il",
    support_title_2: "supporto",
    support_desc_1: "Per bug, domande o cambio dispositivo scrivi direttamente a",
    support_desc_2: ". Oppure usa il form qui sotto.",
    support_email: "La tua email", support_subject: "Oggetto", support_message: "Messaggio",
    support_send: "Invia messaggio",
    support_ok: "Messaggio inviato. Ti risponderemo al piu presto.",
    support_err: "Impossibile inviare",
    // FAQ
    faq_title_1: "Domande", faq_title_2: "frequenti",
    faq_q1: "Cos'e la licenza a vita?",
    faq_a1: "Paghi una sola volta e mantieni l'accesso al tuo piano storage per sempre, senza abbonamenti ricorrenti. Solo le prime 500 licenze fino a fine 2026.",
    faq_q2: "Come ricevo il codice dopo il pagamento?",
    faq_a2: "Subito dopo il pagamento riceverai un codice monouso di 6 caratteri via email. Usa la pagina Riscatta Codice per attivarlo sul tuo account.",
    faq_q3: "Su quanti dispositivi posso accedere?",
    faq_a3: "Ogni account e limitato a 2 dispositivi attivi contemporaneamente. Per cambiare dispositivo, scrivi a st.support25@gmail.com.",
    faq_q4: "Posso fare l'upgrade del mio piano?",
    faq_a4: "Si, dalla dashboard trovi un pulsante Upgrade in alto. Acquista un piano superiore e riscattalo per sostituire il tuo piano attuale.",
    // Security
    sec_1_t: "Crittografia AES-256", sec_1_d: "I tuoi file sono cifrati sia in transito che a riposo. Solo tu puoi accedervi.",
    sec_2_t: "Server ridondanti", sec_2_d: "Backup multipli in datacenter europei. Zero data loss garantito.",
    sec_3_t: "Trasferimenti veloci", sec_3_d: "Upload e download ottimizzati con CDN globale multi-regione.",
    // Errors
    err_email_first: "Inserisci la tua email prima di procedere",
    err_gift_email: "Inserisci l'email del destinatario del regalo",
    err_payment: "Errore durante il pagamento",
    footer: "(c) 2026 NexusCloud - Storage a vita, fatto in Italia.",
    hero_badge_1: "Crittografia AES-256",
    hero_badge_2: "Upload istantaneo",
    hero_badge_3: "Multi-dispositivo",
    // Dashboard
    db_upgrade: "Upgrade piano", db_redeem: "Riscatta", db_logout: "Esci",
    db_storage_active: "Storage attivo - Piano",
    db_no_plan: "Nessun piano - riscatta un codice per iniziare",
    db_pct_used: "utilizzato",
    db_no_plan_btn: "Riscatta il tuo codice",
    db_drop_title: "Trascina i tuoi file qui",
    db_drop_sub_1: "Foto, video, documenti - fino a",
    db_drop_sub_2: "disponibili",
    db_choose: "Scegli file", db_uploading: "Caricamento...",
    db_search: "Cerca file...", db_no_files: "Nessun file da mostrare.",
    db_download: "Scarica", db_devices_title: "Dispositivi attivi",
    db_devices_sub_1: "Massimo 2 dispositivi. Per cambiare dispositivo scrivi a",
    db_devices_none: "Nessun dispositivo attivo",
    db_devices_active: "attivi",
    db_devices_hint: "Puoi essere collegato su 2 dispositivi contemporaneamente. Se esci da uno dei due, puoi accedere da qualsiasi altro dispositivo (nessun blocco permanente).",
    db_upgrade_title: "Upgrade del tuo piano",
    db_upgrade_desc: "Sceglie un piano superiore. Riceverai un nuovo codice via email da riscattare per sostituire il piano attuale.",
    db_current: "Piano attuale", db_smaller: "Piu piccolo",
    db_upgrade_to: "Upgrade a",
    db_lifetime_once: "A vita - una volta",
    // Redeem
    rd_title: "Riscatta il tuo codice",
    rd_sub: "Inserisci il codice a 6 caratteri ricevuto via email",
    rd_need_auth: "Devi essere autenticato per riscattare un codice.",
    rd_login: "Accedi", rd_register: "Registrati",
    rd_code_label: "Codice di riscatto",
    rd_code_hint: "6 caratteri: maiuscole, minuscole e numeri",
    rd_submit: "Attiva il mio piano", rd_activating: "Attivazione...",
    rd_no_code: "Non hai un codice?",
    rd_buy_link: "Acquista un piano",
    rd_back_home: "Torna alla home",
    rd_err_6: "Il codice deve essere di 6 caratteri",
    rd_ok: "Codice riscattato con successo!",
    rd_err: "Errore riscatto",
    feat_lifetime: "Accesso a vita, nessun abbonamento",
    feat_2_devices: "Fino a 2 dispositivi",
    feat_encryption: "Crittografia end-to-end",
    feat_standard_support: "Supporto standard",
    feat_photo_backup: "Backup foto e video",
    feat_priority_support: "Supporto prioritario",
    feat_shared_pw: "Condivisione con password",
    feat_max_speed: "Velocita massima",
    feat_zero_knowledge: "Zero-knowledge encryption",
    feat_versions_365: "Storico versioni 365 giorni",
    feat_vip_support: "Supporto VIP",
    qty_label: "Quantita:",
    qty_discount: "sconto",
  },
  en: {
    nav_pricing: "Plans", nav_security: "Security", nav_faq: "FAQ", nav_support: "Support",
    nav_login: "Sign in", nav_signup: "Sign up", nav_logout: "Log out",
    nav_dashboard: "Dashboard", nav_redeem: "Redeem code",
    banner_pre: "Lifetime offer limited to",
    banner_licenses: "licenses",
    banner_remain: "- Remaining",
    banner_until: "licenses until end of 2026",
    hero_badge: "Cloud storage with lifetime license",
    hero_title_1: "Your cloud.",
    hero_title_2: "Pay once, keep forever.",
    hero_sub: "Pay once and get up to",
    hero_sub_2: "of secure lifetime storage. Zero subscriptions, zero surprises. Only the first",
    hero_sub_3: "available until end of 2026.",
    hero_cta_pricing: "Choose your plan",
    hero_cta_redeem: "I have a code",
    pricing_title_1: "Lifetime",
    pricing_title_2: "plans",
    pricing_sub: "One payment, storage forever. A one-time code is emailed to you after purchase.",
    pricing_email_label: "Email to receive the code",
    gift_label: "Buy as a gift",
    gift_desc: "The code will be sent to the recipient's email",
    gift_recipient: "Recipient email",
    price_once: "/ one time",
    price_lifetime: "Lifetime - no renewal",
    buy_prefix: "Buy",
    support_title_1: "Contact",
    support_title_2: "support",
    support_desc_1: "For bugs, questions or device changes email us directly at",
    support_desc_2: ". Or use the form below.",
    support_email: "Your email", support_subject: "Subject", support_message: "Message",
    support_send: "Send message",
    support_ok: "Message sent. We'll get back to you shortly.",
    support_err: "Unable to send",
    faq_title_1: "Frequently", faq_title_2: "asked",
    faq_q1: "What is the lifetime license?",
    faq_a1: "Pay once and keep access to your storage plan forever, with no recurring subscriptions. Only the first 500 licenses until end of 2026.",
    faq_q2: "How do I receive the code after payment?",
    faq_a2: "Right after payment you'll receive a 6-character one-time code by email. Use the Redeem Code page to activate it on your account.",
    faq_q3: "How many devices can I use?",
    faq_a3: "Each account is limited to 2 active devices at the same time. To change device, email st.support25@gmail.com.",
    faq_q4: "Can I upgrade my plan?",
    faq_a4: "Yes, from the dashboard you'll find an Upgrade button on top. Buy a higher plan and redeem it to replace your current one.",
    sec_1_t: "AES-256 encryption", sec_1_d: "Your files are encrypted in transit and at rest. Only you can access them.",
    sec_2_t: "Redundant servers", sec_2_d: "Multiple backups in European datacenters. Zero data loss guaranteed.",
    sec_3_t: "Fast transfers", sec_3_d: "Uploads and downloads optimized via a global multi-region CDN.",
    err_email_first: "Enter your email before proceeding",
    err_gift_email: "Enter the recipient's email for the gift",
    err_payment: "Payment error",
    footer: "(c) 2026 NexusCloud - Lifetime storage, crafted in Italy.",
    hero_badge_1: "AES-256 encryption",
    hero_badge_2: "Instant upload",
    hero_badge_3: "Multi-device",
    db_upgrade: "Upgrade plan", db_redeem: "Redeem", db_logout: "Log out",
    db_storage_active: "Active storage - Plan",
    db_no_plan: "No active plan - redeem a code to get started",
    db_pct_used: "used",
    db_no_plan_btn: "Redeem your code",
    db_drop_title: "Drop your files here",
    db_drop_sub_1: "Photos, videos, documents - up to",
    db_drop_sub_2: "available",
    db_choose: "Choose files", db_uploading: "Uploading...",
    db_search: "Search files...", db_no_files: "No files to show.",
    db_download: "Download", db_devices_title: "Active devices",
    db_devices_sub_1: "Max 2 devices. To change device email",
    db_devices_none: "No active devices",
    db_devices_active: "active",
    db_devices_hint: "You can be logged in on 2 devices at the same time. Sign out from one of them to log in from any other device (no permanent lock).",
    db_upgrade_title: "Upgrade your plan",
    db_upgrade_desc: "Choose a bigger plan. You'll get a new code by email to redeem and replace your current plan.",
    db_current: "Current plan", db_smaller: "Smaller",
    db_upgrade_to: "Upgrade to",
    db_lifetime_once: "Lifetime - one time",
    rd_title: "Redeem your code",
    rd_sub: "Enter the 6-character code you received by email",
    rd_need_auth: "You need to sign in to redeem a code.",
    rd_login: "Sign in", rd_register: "Sign up",
    rd_code_label: "Redemption code",
    rd_code_hint: "6 characters: upper, lower and digits",
    rd_submit: "Activate my plan", rd_activating: "Activating...",
    rd_no_code: "Don't have a code?",
    rd_buy_link: "Buy a plan",
    rd_back_home: "Back to home",
    rd_err_6: "The code must be 6 characters",
    rd_ok: "Code redeemed successfully!",
    rd_err: "Redemption error",
    feat_lifetime: "Lifetime access, no subscription",
    feat_2_devices: "Up to 2 devices",
    feat_encryption: "End-to-end encryption",
    feat_standard_support: "Standard support",
    feat_photo_backup: "Photo & video backup",
    feat_priority_support: "Priority support",
    feat_shared_pw: "Password-protected sharing",
    feat_max_speed: "Max transfer speed",
    feat_zero_knowledge: "Zero-knowledge encryption",
    feat_versions_365: "365-day version history",
    feat_vip_support: "VIP support",
    qty_label: "Quantity:",
    qty_discount: "off",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    const saved = localStorage.getItem("nx_lang");
    if (saved) return saved;
    const nav = (navigator.language || "it").toLowerCase();
    return nav.startsWith("it") ? "it" : "en";
  });
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("nx_currency") || (locale === "en" ? "usd" : "eur"));
  const [manualLocale, setManualLocale] = useState(() => !!localStorage.getItem("nx_lang"));
  const [manualCurrency, setManualCurrency] = useState(() => !!localStorage.getItem("nx_currency"));

  useEffect(() => { localStorage.setItem("nx_lang", locale); }, [locale]);
  useEffect(() => { localStorage.setItem("nx_currency", currency); }, [currency]);

  // fetch geo once on first mount if user hasn't picked language/currency
  useEffect(() => {
    if (manualLocale && manualCurrency) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/geo`).then((r) => r.json()).then((g) => {
      if (!manualLocale && g.locale) setLocaleState(g.locale);
      if (!manualCurrency && g.currency) setCurrencyState(g.currency);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setLocale = useCallback((l) => { setManualLocale(true); setLocaleState(l); }, []);
  const setCurrency = useCallback((c) => { setManualCurrency(true); setCurrencyState(c); }, []);

  const t = useCallback((key) => DICT[locale]?.[key] ?? DICT.it[key] ?? key, [locale]);

  const CURRENCY_SYMBOL = useMemo(() => ({ eur: "€", usd: "$", gbp: "£", chf: "CHF ", cad: "CA$" }), []);
  const formatPrice = useCallback((pricesObj) => {
    if (!pricesObj) return "";
    const amt = pricesObj[currency] ?? pricesObj.eur ?? 0;
    const sym = CURRENCY_SYMBOL[currency] || "";
    return `${sym}${amt}`;
  }, [currency, CURRENCY_SYMBOL]);

  const bcp = locale === "en" ? "en-US" : "it-IT";
  const formatBytes = useCallback((bytes) => {
    if (!bytes) return "0 B";
    const units = ["B", "KB", "MB", "GB", "TB"];
    let i = 0; let n = bytes;
    while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
    const nf = new Intl.NumberFormat(bcp, { maximumFractionDigits: n < 10 ? 2 : 1 });
    return `${nf.format(n)} ${units[i]}`;
  }, [bcp]);
  const formatDate = useCallback((iso) => {
    if (!iso) return "";
    try {
      return new Intl.DateTimeFormat(bcp, { day: "2-digit", month: "2-digit", year: "numeric" }).format(new Date(iso));
    } catch { return iso; }
  }, [bcp]);

  const value = useMemo(
    () => ({ locale, setLocale, currency, setCurrency, t, formatPrice, formatBytes, formatDate }),
    [locale, setLocale, currency, setCurrency, t, formatPrice, formatBytes, formatDate]
  );

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export const useT = () => useContext(I18nContext);
